<app-dialog
  [dialogType]="dialogType"
  [headerLabel]="
    'DOCUMENT.' + documentType + '.REMOVE_DEPOSIT_REQUEST_DIALOG.TITLE'
      | uppercase
      | translate
  "
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionText]="
    'DOCUMENT.' + documentType + '.REMOVE_DEPOSIT_REQUEST_DIALOG.YES_REMOVE'
      | uppercase
      | translate
  "
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionText]="
    'DOCUMENT.' + documentType + '.REMOVE_DEPOSIT_REQUEST_DIALOG.NO_KEEP_ON'
      | uppercase
      | translate
  "
  [secondaryActionTapped]="secondaryActionTapped"
  [stackActions]="true"
  (onPrimaryAction)="onRemoveDepositRequest.emit()"
>
  <div id="remove-deposit-request-dialog">
    <p class="description">
      {{
        'DOCUMENT.' + documentType + '.REMOVE_DEPOSIT_REQUEST_DIALOG.INFO'
          | uppercase
          | translate
      }}
    </p>
  </div>
</app-dialog>
